<template>
    <div class="talent-deail-container">
        <h2>人才详情页</h2>
        <div style="position: absolute;right: 20px; cursor: pointer;z-index: 999;">
            <el-button type="text" class="copy-btn"
                :data-clipboard-text="`${frontUrl}/resume/detail/${userInfo.userId}`" @click="copy">复制链接
            </el-button>
        </div>
        <el-form :inline="true" class="demo-form-inline">
            <el-row :gutter="20">
                <el-col :span="10">
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <h3 style="margin-bottom: 12px;">用户基本信息</h3>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="用户名称">
                                <el-input v-model="userInfo.nickname" placeholder="用户名称"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="认证证书">
                                <el-input :value="userEdus.length ? userEdus[0].certificate : ''"
                                    placeholder="认证证书"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="学历">
                                <el-input :value="getDegree(userInfo.degree)" placeholder="学历"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="手续费">
                                <el-input v-model="userInfo.fee" placeholder="手续费"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="大学名称">
                                <el-input :value="userEdus.length ? userEdus[0].schoolName : ''"
                                    placeholder="大学名称"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="成单数">
                                <el-input v-model="orderNum" placeholder="成单数"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="工作年限">
                                <el-input :value="getYears(userInfo.workYears)" placeholder="工作年限"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="是否认证">
                                <el-input :value="userInfo.accountAuthenticationStatus == 2 ? '是' : '否'"
                                    placeholder="是否认证"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="专业类目">
                                <el-input :value="userInfo.skillsTagArr" placeholder="专业类目"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="最后登录时间">
                                <el-input v-model="userInfo.lastOnlineTime" placeholder="最后登录时间"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="技能标签">
                                <!-- <el-input :value="userInfo.thirdSkillTags" placeholder="技能标签"></el-input> -->
                                <div v-if='userInfo.thirdSkillTags.length > 0'
                                    style="display: flex;flex-direction: row; flex-wrap: wrap;align-items: center;border: 1px solid #dcdfe6;padding:0 12px;border-radius: 4px;">
                                    <div v-for="item in userInfo.thirdSkillTags">{{ item.name }},</div>
                                </div>
                                <div v-else
                                    style="display: flex;flex-direction: row; flex-wrap: wrap;align-items: center;border: 1px solid #dcdfe6;padding:0 12px;border-radius: 4px;">
                                    空
                                </div>
                            </el-form-item>
                        </el-col>

                    </el-row>
                </el-col>
                <el-col :span="14">
                    <el-row>
                        <el-col :span="24">
                            <h3 style="margin-bottom: 12px;">工作能力</h3>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="工作能力描述">
                                <el-input v-model="userInfo.description" placeholder="工作能力描述"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="工作能力内容">
                                <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 10 }" placeholder="请输入内容"
                                    v-model="userInfo.careerExperience">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <div style="font-size: 18px;font-weight: bold;margin-bottom: 12px; ">工作经历</div>
                        </el-col>
                        <el-col :span="12">
                            <div style="display: flex;align-items: center;flex-direction: row;">
                                <div class="click-number" :class="{ 'click-active': index == tabPosition }"
                                    v-for="(item, index) in userResumes" @click="tabPosition = index">{{ index + 1 }}
                                </div>
                            </div>
                        </el-col>
                        <el-row :gutter="20">
                            <el-col :span="24">
                                <div class="job-content">
                                    <div class="content-flex-row">
                                        <span><label style="color: black;font-weight: bold;">工作公司:</label><label>{{
                                                userResumes[tabPosition].corporateName }}</label></span>
                                        <span><label style="color: black;font-weight: bold;">工作职位:</label><label>{{
                                                userResumes[tabPosition].jobTitle }}</label> </span>
                                    </div>
                                    <div style="margin-top: 10px;margin-bottom: 8px"> <label style="color: black;font-weight: bold;">工作内容</label></div>
                                    <div style="font-size: 14px;color: rgb(96, 98, 102);">{{
                                        userResumes[tabPosition].jobContent }}</div>
                                </div>
                            </el-col>
                        </el-row>
                    </el-row>
                    <el-row :gutter="20" style="margin-top: 20px;">
                        <el-col :span="12">
                            <div
                                style="font-size: 18px;font-weight: bold;margin-bottom: 12px;color: black;font-weight: bold;">
                                项目经历</div>
                        </el-col>
                        <el-col :span="12">
                            <div style="display: flex;align-items: center;flex-direction: row;">
                                <div class="click-number" :class="{ 'click-active': index == tabPosition2 }"
                                    v-for="(item, index) in userProjects" @click="tabPosition2 = index">{{ index + 1 }}
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <div class="job-content">
                            <div class="content-flex-row">
                                <span><label style="color: black;font-weight: bold;">项目名称:</label><label>{{
                                        userProjects[tabPosition2].projectName }}</label></span>
                                <span><label style="color: black;font-weight: bold;">项目时间:</label> <label>{{
                                        userProjects[tabPosition2].startTime }} - {{
                                            userProjects[tabPosition2].endTime }}</label></span>
                            </div>
                            <div style="margin-top: 10px;margin-bottom: 8px;">
                                <label style="color: black;font-weight: bold;">项目内容</label></div>
                            <div style="font-size: 14px;color: rgb(96, 98, 102);">{{
                                userProjects[tabPosition2].projectDesc }}</div>
                        </div>
                    </el-row>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>
<script>
import { active } from 'sortablejs';
import api from '../api'
// import request from '../request'
import Clipboard from "clipboard";

// const check = '/user/updateUserStatus'

const {
    user
} = api

export default {
    name: '',
    data() {
        return {
            tabPosition: 0,
            tabPosition2: 0,
            textarea2: 'right',
            labelPosition: 'right',
            data: {},
            userInfo: {}, // 用户信息
            sameIds: {},
            status: {
                0: '未认证',
                1: '审核中',
                2: '已认证',
            },
            isSubmiting: false,
            reasons: [],
            userEdus: [],
            userProjects: [],
            userResumes: [],
            orderNum: ''
        }
    },
    computed: {
        userId() {
            return this.$route.params.id;
        },
    },
    methods: {
        copy() {
            var clipboard = new Clipboard(".copy-btn");
            clipboard.on("success", (e) => {
                this.$message.success("复制成功");
                // 释放内存
                clipboard.destroy();
            });
            clipboard.on("error", (e) => {
                // 不支持复制
                this.$message.error("复制失败，请手动复制收款地址");
                // 释放内存
                clipboard.destroy();
            });
        },
        getDegree(degree) {
            let userDegree;
            switch (degree) {
                case "0":
                    userDegree = "大专";
                    break;
                case "1":
                    userDegree = "本科";
                    break;
                case "2":
                    userDegree = "硕士";
                    break;
                case "3":
                    userDegree = "博士";
                    break;
                default:
                    userDegree = "其他";
                    break;
            }
            return userDegree;
        },
        getYears(Years) {
            let workYears;
            switch (Years) {
                case 1:
                    workYears = "一年以下";
                    break;
                case 2:
                    workYears = "1-3年";
                    break;
                case 3:
                    workYears = "3-5年";
                    break;
                case 4:
                    workYears = "5-10年";
                    break;
                case 5:
                    workYears = "10年以上";
                    break;
            }
            return workYears;
        },
        async getUserById() {
            let obj = {
                userId: this.userId
            };
            let {
                data: {
                    code,
                    data
                }
            } = await api.talentPool.detail(obj)
            if (code === 200) {
                this.data = data
                this.userInfo = data.user;
                this.userEdus = data.userEdus;
                this.userProjects = data.userProjects;
                this.userResumes = data.userResumes;
                this.orderNum = data.orderNum
            }
        },

        goBack() {
            this.$router.go(-1)
        },
    },
    created() {
        this.getUserById()
    },
}
</script>
<style>
.talent-deail-container .el-form-item__content {
    width: 100% !important;
}

.content-flex-row {
    display: flex;
    align-items: center;
    justify-content: space-between;

}

.click-number {
    border: 1px solid #dcdfe6;
    border-radius: 100px;
    width: 24px;
    height: 24px;
    text-align: center;
    line-height: 24px;
    margin-left: 10px;
    cursor: pointer;
    z-index: 99;
}

.click-active {
    background-color: rgb(26, 179, 148);
}

.job-content label {
    margin-right: 10px;
    color: #606266;
    font-size: 14px;
}

.job-content {
    padding: 12px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    max-height: 180px;
    overflow-y: scroll;
    margin-left: 10px;
}

.talent-deail-container .el-form-item {
    width: 100%;
    margin-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/views/user/talent-deail.vue